import { useCallback, useState } from 'react';
import { Avatar, Card, CardContent, Link, Typography } from '@mui/material';
import { EmailIcon, SkypeShapeIcon as SkypeIcon } from '@images/icons';
import { FEEDBACK_FORM_SUBJECT } from '@constants/index';
import { ImageLoader } from '@sharedComponents/ImageLoader/ImageLoader';
import { convertImageToBase64, generateInitialsAvatar, getUserInitials } from '@utils';
import { ImageShape } from '@enums';

import './index.scss';

interface Props {
  name: string;
  position: string;
  skype: string;
  email: string;
  userId: string;
}

export const UserInfo = ({ name, position, skype, email, userId }: Props) => {
  const [image, setImage] = useState(null);

  const handleOnLoad = useCallback((event) => {
    setImage(convertImageToBase64(event.target, ImageShape.CIRCLE));
  }, []);
  const handleOnError = useCallback(() => {
    generateInitialsAvatar(name, ImageShape.CIRCLE);
  }, []);

  return (
    <Card className="user-card" data-testid="user-card">
      <ImageLoader userId={userId} onLoad={handleOnLoad} onError={handleOnError} />
      <Avatar
        data-testid="user-card__avatar"
        className="user-card__avatar"
        alt={`${getUserInitials(name)}`}
        src={image}
      >
        {getUserInitials(name)}
      </Avatar>
      <CardContent>
        <Typography className="user-card__name">{name}</Typography>
        <Typography className="user-card__position">{position}</Typography>
        {skype && (
          <Link
            href={`skype:${skype}?chat`}
            className="user-card__link"
            target="_blank"
            underline="none"
          >
            <SkypeIcon />
            <Typography>Skype</Typography>
          </Link>
        )}
        {email && (
          <Link
            href={`mailto:${email}?subject=${FEEDBACK_FORM_SUBJECT}`}
            className="user-card__link"
            target="_blank"
            underline="none"
          >
            <EmailIcon />
            <Typography>Email</Typography>
          </Link>
        )}
      </CardContent>
    </Card>
  );
};
